import z from 'zod'

export const UserAddressKindEnum = z.enum(['HOUSE', 'APARTMENT', 'OFFICE', 'OTHER'])
export const UserAddressFieldTypeEnum = z.enum([
  'STREET_NAME',
  'STREET_NUMBER',
  'ADDITIONAL_INFORMATION',
  'FLOOR_NUMBER',
  'DOOR_NUMBER',
  'BUILDING_NAME',
  'POSTAL_CODE',
  'STAIRCASE',
  'DISTRICT',
  'INTERSECTION',
  'PROVINCE',
])

export const UserAddressTagEnum = z.enum(['HOME', 'WORK', 'FLAT', 'HOSPITAL', 'OFFICE', 'SCHOOL'])

export const UserAddressSchema = z.object({
  id: z.number(),
  addressLine: z.string(),
  details: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  countryCode: z.string(),
  cityCode: z.string(),
  cityName: z.string(),
  kind: UserAddressKindEnum,
  tag: z
    .string()
    .nullish()
    .transform((x) => x || null),
  fields: z
    .object({
      type: UserAddressFieldTypeEnum,
      value: z.string(),
    })
    .array(),
})

export const UserAddressNewSchema = UserAddressSchema.omit({
  id: true,
})

export const GoogleAddressSchema = z.object({
  placeId: z.string(),
  title: z.string(),
  subtitle: z.string(),
  types: z.string().array(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  fullAddress: z.string().nullable(),
  cityCode: z.string().nullable(),
  countryCode: z.string().nullable(),
  addressComponents: z.object({
    route: z.string().nullish(),
    administrative_area_level_2: z.string().nullish(),
    political: z.string().nullish(),
    locality: z.string().nullish(),
    street_number: z.string().nullish(),
    sublocality: z.string().nullish(),
    sublocality_level_1: z.string().nullish(),
    administrative_area_level_1: z.string().nullish(),
    postal_code: z.string().nullish(),
    country: z.string().nullish(),
  }),
})

export const GoogleAddressCompactSchema = GoogleAddressSchema.extend({
  addressComponents: GoogleAddressSchema.shape.addressComponents.nullable(),
})

export interface AddressCoordinates {
  latitude: number
  longitude: number
}

export type UserAddress = z.infer<typeof UserAddressSchema>
export type UserAddressNew = z.infer<typeof UserAddressNewSchema>
export type GoogleAddress = z.infer<typeof GoogleAddressSchema>
export type GoogleAddressCompact = z.infer<typeof GoogleAddressCompactSchema>

export type UserAddressTag = z.infer<typeof UserAddressTagEnum>
export type UserAddressKind = z.infer<typeof UserAddressKindEnum>
export type UserAddressFieldType = z.infer<typeof UserAddressFieldTypeEnum>
